import type { FaireProductEntity } from "../../entity_types/product";

export const p_evsyvcvubz: FaireProductEntity = {
  token: "p_evsyvcvubz",
  type: "product",
  name: "50mL Perfume - Dulce de Cuerpo",
  brandToken: "b_c3hepkjc1t",
  brandName: "Nopalera",
  imageUrl:
    "https://cdn.faire.com/fastly/4158649d9c26986e928c9d6066012b1a1e3d47c25bf85606dbdadafeb654cae4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/28d1b57f726d37aea49db42de9bd0aef0be3cfb97f70b000ca2de93b768a5533.jpeg",
    "https://cdn.faire.com/fastly/467d9bd084ae0952f48df2d14b06bb579ff35d9de37e5fe819c21990e214c203.jpeg",
    "https://cdn.faire.com/fastly/e41906caac875fa96dece9eb053372681cde088533ab8da9f4498165e1b6a363.jpeg",
    "https://cdn.faire.com/fastly/51fe2b76523125462f1c276ba05dfd464179734e38e742ace1e2d918b1655b27.jpeg",
    "https://cdn.faire.com/fastly/37332fe94845330d2deaff33bd0d386e3725f492d5955ff22d3304848bd33fda.jpeg",
    "https://cdn.faire.com/fastly/5cc5e6c9d1c01442594b562a79780f3b2c0f78dc7ae874b5d0dd4dc6068d0200.jpeg",
  ],
  priceDollars: 39,
  description:
    "Powerfully smoky and enduring, Dulce de Cuerpo eau de parfum captures the essence of Mexico City and its enchanting Pueblos Mágicos. Sweet earth blends with violet and amber, while copal, vanilla, and sandalwood envelop you in warmth. Perfect as your signature scent, from dawn to dusk and beyond. Gender neutral scent.\n\nTOP: Sweet Earth\nMID: Incense, Amber, Violet\nBASE: Copal, Vanilla, Sandalwood\n\nClean formulation with no phthalates, parabens or sulfates\nVegan | Cruelty free | Gluten free\n\nInstructions for use: Spray on pulse points, where  skin is naturally warmer. These areas include the wrists, behind the ears, the inner elbows. The warmth will help to release the fragrance throughout the day. Keep your perfume in a cool, dry place away from direct sunlight and heat to preserve its integrity and longevity.\n\nhttps://nopalera.co/blogs/news/why-clean-fragrance-is-better-for-your-health\n\n\nWe are a clean brand. Our products are vegan and free from hormone disruptors and phthalates.",
  tags: [],
  msrpDollars: 78,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:20:45.374Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
